import { useCallback, useEffect, useMemo, useRef } from "react";
import type { Timeout } from "whole-shared";

export const useTimeout = () => {
  const timeout = useRef<Timeout | undefined>(undefined);

  const clear = useCallback(() => {
    if(timeout.current !== undefined) {
      clearTimeout(timeout.current);
      timeout.current = undefined;
    }
  }, []);

  const set = useCallback(
    (handler: () => void, delay: number) => {
      clear();
      timeout.current = setTimeout(() => {
        timeout.current = undefined;
        handler();
      }, delay);
    },
    [clear]
  );

  useEffect(() => clear, [clear]);

  return useMemo(() => ({ clear, set }), [clear, set]);
};
